// QRModalContext.js
import React, { createContext, useContext, useState } from 'react';
import { generateQRData } from '../Components/SharedFiles/Helper/utils';

const QRModalContext = createContext();

export const QRModalProvider = ({ children }) => {
  const [QRmodalOpen, setQRmodalOpen] = useState(false);
  const [QRdata, setQrData] = useState("");
  const [submitHandler, setSubmitHandler] = useState(null);
  const [page, setPageName] = useState("");
  const [printStatus,setPrintStatus]=useState(false);
  const [printedRowss, setPrintedRows] = useState([]);
  const [rowIndex, setRowIndex] = useState("");

  const PrintLabel = (data,index =null, page = '', onSubmit = null) => {
    const GenQrData = generateQRData(data,page) 
    console.log("data",data);
    console.log("GenQrData",GenQrData);
    setQrData(GenQrData);
    setRowIndex(index);
    setPageName(page);
    setSubmitHandler(() => onSubmit); 
    setQRmodalOpen(true);
  };


  const closeQRModal = (onCloseCallback = null) => {
    setQRmodalOpen(false);
    setQrData("");
    setSubmitHandler(null);
    setPrintStatus(false);
  
    if (typeof onCloseCallback === 'function') {
      onCloseCallback();
    }
  };
  

  return (
    <QRModalContext.Provider value={{
      QRmodalOpen,
      QRdata,
      PrintLabel,
      closeQRModal,
      setQrData,
      setQRmodalOpen,
      setPrintStatus,
      printStatus,
      page,
      rowIndex,
      submitHandler,
      setPrintedRows,
      printedRowss
    }}>
      {children}
    </QRModalContext.Provider>
  );
};

// Custom hook
export const useQRModal = () => useContext(QRModalContext);
